import { Button } from 'primereact/button';
import styles from './BackButton.module.css';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  to?: string;
}

const BackButton = ({ to }: BackButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      label="Back"
      icon="pi pi-arrow-left"
      className={styles.backButton}
      text
      aria-label="Go back"
      onClick={() => (to ? navigate(`${to}`) : navigate(-1))}
    />
  );
};

export default BackButton;
